<agpr-dialog-container
    [id]="id"
    heading="RSSFeeds.create"
    (close)="cancel()"
>
    <div class="agpr-rssFeedCreateDialog-content">
        <div class="agpr-inputGroup">
            <agpr-text-input
                [id]="id + '_nameInput'"
                label="RSSFeeds.name"
                [initialFocus]="true"
                [maxLength]="64"
                placeholder="RSSFeeds.name.placeholder"
                [(ngModel)]="feed.name"
                (ngModelChange)="clearErrors()"
            ></agpr-text-input>
        </div>

        @if (showErrors && nameFieldErrors.empty) {
            <agpr-form-message>
                {{ 'RSSFeeds.name.errors.empty' | localize }}
            </agpr-form-message>
        }

        @if (showErrors && nameFieldErrors.duplicate) {
            <agpr-form-message>
                {{ 'RSSFeeds.name.errors.duplicate' | localize }}
            </agpr-form-message>
        }

        <div class="agpr-inputGroup">
            <agpr-textarea-input
                [id]="id + '_descriptionInput'"
                label="RSSFeeds.description"
                placeholder="RSSFeeds.description.placeholder"
                [(ngModel)]="feed.description"
            ></agpr-textarea-input>
        </div>

        <div class="agpr-inputGroup">
            <agpr-dropdown
                [id]="id + '_limitDropdown'"
                label="RSSFeeds.maxItems"
                [options]="itemsLimitOptions"
                [(ngModel)]="selectedItemsLimitOption"
                (ngModelChange)="itemsLimitChanged($event.value)"
            ></agpr-dropdown>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_createButton'"
            label="RSSFeeds.create"
            [style]="buttonTypes.primary"
            (click)="createFeed()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
